﻿import React, { useState, useMemo, useContext, useEffect } from 'react';
import {
  Widget,
  Button,
  usePromise,
  CrudContext,
  ButtonDelete,
  FormSelect,
  MasterDetailForm,
  Row,
} from '@digital/ui';
import {
  getAllPlanilhaQuantidadeContratoByContrato,
  getAllPlanilhaQuantidadeAtualByContrato,
  getAllPlanilhaQuantidadeContratoTemporariaByContrato,
  getExportaPqTemporaria,
  getExportarPqAtual,
  postExcluirPqTemporaria,
  postAprovarPq,
  postReprovarPq,
  getVerificarTemporariaComStatusReprovada,
  getVerofocarTemporariaComStatusAguardandoAprovacao,
  getExportarTaKeOf,
  getExportarTaKeOfAtual,
  postExcluirPqById,
  ContratoPlanilhaQuantidadeAtual,
  PlanilhaQuantidadeTemporaria,
  getAllTipoDocumentoCobrancaOptions,
  updateTipoDocumentoCobranca,
  getAllPlanilhaQuantidadeMultiplosGestoresByContrato,
  getExportarPqAtualMultiplosGestores,
  getExportarPqTakeOffMultiplosGestores,
  GetTakeOfMultiplosGestores,
} from '@app/api/contrato/planilhaQuantidadeContrato';

import { Icon, Collapse, Modal, Tooltip, Table } from 'antd';
import ComponeteCurso from '../../../components/componeteCurso';
import { hasPermission } from '@app/helpers/permissions';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { GetVerificarSeContratoEstaComStatusPreCadastradoByContratoId } from '@app/api/contrato';
import ModalDefineMultiplosGestores from './ModalDefineMultiplosGestores'
import ModalAdicionaEscopoPQ from './ModalAdicionaEscopoPQ';
import { AbaPQEscopoMultiplosGestores, consolidarPqsMultiplosGestores, deleteAllPqMultiplosGestores } from '@app/api/contrato/contratoBase';
import { Visibility } from '@app/components/Visibility';
import WidgetPQMultiplosGestores from './WidgetPQMultiplosGestores';
import './custom.css'; 
import { compareStrings } from '@app/helpers/stringHelper';
import { isObjNotEmpty } from '@app/helpers/objHelper';
interface AbaPQFormProps {
  isDefined?: boolean;
  isMultiplosGestores?: boolean;
  onUpdate: () => any;
  setIsConsolidado: React.Dispatch<React.SetStateAction<boolean>>;
  isConsolidado: boolean;
}

const AbaPlanilhaQuantidadeContrato = (props: AbaPQFormProps) => {
  const { isDefined, isMultiplosGestores, onUpdate, setIsConsolidado, isConsolidado} = props;

  const handleEditLinhaPq = (record: any, value: any) => {
    updateTipoDocumentoCobranca(record.id, value).then(data => {
      if (data) {
        if (data.valid) {
          setItemAdded(!itemAdded);
          setItemAdded(!itemAdded);
        }
      }
    });
  };

  const PlanilhaQuantidadeContratoColumns = [
    {
      title: 'Número',
      dataIndex: 'numero',
      width: '7%',
    },
    {
      title: 'Status',
      dataIndex: 'statusPlanilha',
      width: '20%',
    },
    {
      title: 'Data de inclusão',
      dataIndex: 'dataInclusaoFormatada',
      width: '7%',
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      width: '26%',
    },
    {
      title: 'Aditivo Relacionado',
      dataIndex: 'aditivoRelacionado',
      width: '10%',
    },
    {
      title: 'Valor do Contrato',
      dataIndex: 'valorContratoFormatado',
      width: '20%',
    },
  ];

  const PlanilhaQuantidadeColumns = [
    {
      title: 'Item',
      dataIndex: 'codigoItem',
      editable: { inputType: 'text' },
      width: '15%',
    },
    {
      title: 'Descrição',
      dataIndex: 'descricao',
      editable: { inputType: 'text' },
      width: '36%',
    },
    {
      title: 'DOC. COBRANÇA',
      dataIndex: 'tipoDocumentoCobrancaId',
      render: (text, record, index) => {
        return (
          <FormSelect
            disabled={!hasPermission(['CONTRATO_PQ_CADASTRAR', 'CONTRATO_PQ_AJUSTAR', 'CONTRATO_PQ_AJUSTAR'])}
            options={tipoDocumentoCobranca}
            value={record.tipoDocumentoCobrancaId}
            name={`documentoCobranca-${record.id}`}
            onChange={e => handleEditLinhaPq(record, e)}
          />
        );
      },
      width: '10%',
    },
    {
      title: 'Unidade',
      dataIndex: 'unidade',
      editable: { inputType: 'text' },
      width: '5%',
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantidade',
      editable: { inputType: 'number' },
      width: '10%',
    },
    {
      title: 'Preço unitário',
      dataIndex: 'precoUnitario',
      editable: { inputType: 'text' },
      width: '17%',
    },
    {
      title: 'Valor Total',
      dataIndex: 'valorTotal',
      editable: { inputType: 'text' },
      width: '17%',
    },
  ];

  const PlanilhaQuantidadeTemporariaColumns = [
    {
      title: 'Item',
      dataIndex: 'codigoItem',
      editable: { inputType: 'text' },
      width: '15%',
    },
    {
      title: 'Descrição',
      dataIndex: 'descricao',
      editable: { inputType: 'text' },
      width: '36%',
    },
    {
      title: 'Unidade',
      dataIndex: 'unidade',
      editable: { inputType: 'text' },
      width: '5%',
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantidade',
      editable: { inputType: 'number' },
      width: '10%',
    },
    {
      title: 'Preço unitário',
      dataIndex: 'precoUnitario',
      editable: { inputType: 'text' },
      width: '17%',
    },
    {
      title: 'Valor Total',
      dataIndex: 'valorTotal',
      editable: { inputType: 'text' },
      width: '17%',
    },
  ];

  const { Panel } = Collapse;
  const { selectedItem } = useContext(CrudContext);

  const [itemAdded, setItemAdded] = useState(false);
  const [hasPQ, sethasPQ] = useState(false);
  const [mostraGridPqTemporaria, setmostraGridPqTemporaria] = useState(false);

  const [hasRecarregarBotaoGrid, sethasRecarregarBotaoGrid] = useState(false);
  const [hasRecarregarBotaoGridTemporaria, sethasRecarregarBotaoGridTemporaria] = useState(false);

  const [hasPQBtCorriPq, sethasPQBtCorriPq] = useState(false);
  const [hasContratoPreCadastrador, setContratoPreCadastrador] = useState(false);

  const [hasPQBtAjustePq, sethasPQBtAjustePq] = useState(false);
  const [hasPQBtAprovarPq, sethasPQBtAprovarPq] = useState(false);
  const [hasPQBtReprovarPq, sethasPQBtReprovarPq] = useState(false);

  const [hasAcaoAprovarPq, setAcaoAprovarPq] = useState(false);
  const [hasAcaoReprovarPq, setAcaoReprovarPq] = useState(false);
  const [hasAcaoCorrigoPq, setAcaoCorrigoPq] = useState(false);

  const [hasAcaoAjustarPq, sethasAcaoAjustarPq] = useState(false);
  const [hasAtualizarGridPrincipal, sethasAtualizarGridPrincipal] = useState(false);

  const [btnExpandirAtual, setBtnExpandirAtual] = useState(true);
  const [PqRowExpandedAtual, setPqRowExpandedAtual] = useState(['']);
  const [PqExpandableRowsAtual, setPqExpandableRowsAtual] = useState(['']);

  const [btnExpandirTemp, setBtnExpandirTemp] = useState(true);
  const [PqRowExpandedTemp, setPqRowExpandedTemp] = useState(['']);
  const [PqExpandableRowsTemp, setPqExpandableRowsTemp] = useState(['']);

  const [tipoDocumentoCobranca, setTipoDocumentoCobranca] = useState([{}]);
  const [consolidado, setConsolidado] = useState(false);

  const [allPqUltimosGestores, setAllPqUltimosGestores] = useState<ContratoPlanilhaQuantidadeAtual[]>([]);

  const [contratoPlanilhaQuantidadeAtual, setContratoPlanilhaQuantidadeAtual] = useState<
    ContratoPlanilhaQuantidadeAtual[]
  >();

  const [multiplosGestoresEscopo, setMultiplosGestoresEscopo] = useState<AbaPQEscopoMultiplosGestores[]>([]);

  useMemo(() => {
    if (selectedItem) {
      getAllTipoDocumentoCobrancaOptions(selectedItem.id).then(data => {
        setTipoDocumentoCobranca(data);
      });
      setIsConsolidado(selectedItem.isConsolidado);
      setConsolidado(selectedItem.isConsolidado);
    }
  }, [selectedItem]);

  const botoesAcaoGridPqTemporaria = useMemo(() => {
    const actions = [];

    actions.push(
      <Button
        onClick={() => {
          setBtnExpandirTemp(!btnExpandirTemp);
        }}
        name="btnExpandirPqTemp"
        title={btnExpandirTemp ? 'Expandir' : 'Contrair'}
        type="link"
      />,
    );

    if (hasPermission(['CONTRATO_PQ_EXPORTAR_TEMPORARIA'])) {
      actions.push(
        <Button
          type="link"
          icon="files-xls"
          onClick={() => {
            getExportaPqTemporaria(selectedItem.id);
          }}>
          Exportar PQ temporária
        </Button>,
      );
    }

    if (hasPermission(['CONTRATO_PQ_EXCLUIR_TEMPORARIA'])) {
      actions.push(
        <ButtonDelete
          icon={null}
          type="link"
          okText="OK"
          confirm="Confirma exclusão de Planilha de Quantidade Temporária?"
          onClick={() => {
            postExcluirPqTemporaria(selectedItem.id).then(data => {
              if (data.valid) {
                location.reload();
              }
            });
          }}
        />,
      );
    }

    if (hasPermission(['CONTRATO_PQ_REPROVAR'])) {
      if (hasPQBtReprovarPq) {
        actions.push(
          <Button
            type="link"
            icon="hands-thumbs_down"
            title="Reprovar"
            confirm="Deseja reprovar a Planilha de Quantidade?"
            okText="OK"
            onClick={() => {
              postReprovarPq(selectedItem.id).then(data => {
                if (data) {
                  if (data.valid) {
                    sethasPQBtReprovarPq(false);
                    sethasPQBtAprovarPq(false);
                    setAcaoReprovarPq(!hasAcaoReprovarPq);
                    sethasRecarregarBotaoGridTemporaria(!hasRecarregarBotaoGridTemporaria);
                  }
                }
              });
            }}
          />,
        );
      }
    }

    if (hasPermission(['CONTRATO_PQ_APROVAR'])) {
      if (hasPQBtAprovarPq) {
        actions.push(
          <Button
            type="link"
            icon="hands-thumbs_up"
            confirm="Deseja aprovar a Planilha de Quantidade?"
            title="Aprovar"
            okText="ok"
            onClick={() => {
              postAprovarPq(selectedItem.id).then(data => {
                setAcaoAprovarPq(!hasAcaoAprovarPq);
                setmostraGridPqTemporaria(!mostraGridPqTemporaria);
                setmostraGridPqTemporaria(false);
              });
            }}
          />,
        );
      }
    }

    if (hasPermission(['CONTRATO_PQ_AJUSTAR'])) {
      if (hasPQBtAjustePq) {
        actions.push(
          <ComponeteCurso
            id={selectedItem && selectedItem.id}
            nomeIdFormulario={'ContratoId'}
            enderecoApi={'contratos/UpdatePlanilhaQuantidadeContratoAjustar'}
            descricaoBotao={'Ajustar PQ'}
            retorno={data => {
              if (data.valid) {
                sethasAcaoAjustarPq(true);
                sethasPQBtAjustePq(false);
                sethasRecarregarBotaoGridTemporaria(!hasRecarregarBotaoGridTemporaria);
              }
            }}
            idDoComponente="importAjutarPq"
          />,
        );
      }
    }
    return actions;
  }, [hasRecarregarBotaoGridTemporaria, btnExpandirTemp]);

  const CalBackRetornoUpdateArquivoCorrirPq = (data: any) => {
    if (data) {
      if (data.valid) {
        sethasPQBtCorriPq(false);
        sethasRecarregarBotaoGrid(!hasRecarregarBotaoGrid);
        setmostraGridPqTemporaria(true);
        setAcaoCorrigoPq(!hasAcaoCorrigoPq);

        getVerificarTemporariaComStatusReprovada(selectedItem.id).then(dataReprovado => {
          if (dataReprovado) {
            sethasPQBtAjustePq(!hasPQBtAjustePq);
            sethasPQBtAjustePq(true);
          }
        });
      }
    }
  };

  const botoesDeAcaoPqAtual = useMemo(() => {
    const actions = [];

    actions.push(
      <Button
        onClick={() => {
          setBtnExpandirAtual(!btnExpandirAtual);
        }}
        name="btnExpandirPqAtual"
        title={btnExpandirAtual ? 'Expandir' : 'Contrair'}
        type="link"
      />,
    );

    if (hasPermission(['CONTRATO_PQ_EXPORTAR_ATUAL'])) {
      actions.push(
        <Button
          type="link"
          icon="files-xls"
          onClick={() => {
            getExportarPqAtual(selectedItem.id);
          }}>
          Exportar PQ atual
        </Button>,
      );
    }

    if (hasPermission(['CONTRATO_PQ_CORRIGIR'])) {
      if (hasPQBtCorriPq) {
        actions.push(
          <ComponeteCurso
            id={selectedItem && selectedItem.id}
            nomeIdFormulario={'ContratoId'}
            enderecoApi={'contratos/updatePlanilhaQuantidadeContratoCorrigir'}
            descricaoBotao={'Corrigir PQ'}
            retorno={CalBackRetornoUpdateArquivoCorrirPq}
            idDoComponente="importCorrigirPq"
          />,
        );
      }

      if (hasContratoPreCadastrador) {
        actions.push(
          <ButtonDelete
            icon={null}
            type="link"
            okText="OK"
            confirm="Confirma exclusão de Planilha de Quantidade?"
            onClick={() => {
              postExcluirPqById(selectedItem.id).then(data => {
                if (data.valid) {
                  sethasAtualizarGridPrincipal(true);
                  sethasAtualizarGridPrincipal(false);
                }
              });
            }}
          />,
        );
      }
    }

    return actions;
  }, [hasRecarregarBotaoGrid, hasContratoPreCadastrador, hasPQBtCorriPq, btnExpandirAtual]);

  const botoesDeAcaoPqGridPrincipal = useMemo(() => {
    const actions = [];

    actions.push(
      <Button
        type="primary"
        icon="files-xls"
        onClick={() => {
          if (selectedItem) {
            getExportarTaKeOf(selectedItem.id);
          }
        }}>
        Exportar Take-Off Anterior
      </Button>,
    );

    actions.push(
      <Button
        type="primary"
        icon="files-xls"
        onClick={() => {
          if (selectedItem) {
            getExportarTaKeOfAtual(selectedItem.id);
          }
        }}>
        Exportar Take-Off Atual
      </Button>,
    );

    return actions;
  }, [selectedItem]);

  const CalBackAcaoAssociarPq = (data: any) => {
    if (data) {
      if (data.valid) {
        setItemAdded(!itemAdded);
        setItemAdded(true);
      }
    }
  };

  const ConsolidarPqsMultiplosGestores = () => {
    consolidarPqsMultiplosGestores(selectedItem && selectedItem.id).then((resp:any)=>{
      if(resp.valid){
        setIsConsolidado(true);
        setConsolidado(true);
      }
    });
  }

  const DeleteAllPqMultiplosGestores = () => {
    deleteAllPqMultiplosGestores(selectedItem && selectedItem.id).then((resp: any)=>{
      if(resp.valid)
        GetPQMultiplosGestores();
    })
  }

  const [planilhaQuantidadeContratoTemporariaByContrato] = usePromise(
    () =>
      selectedItem
        ? getAllPlanilhaQuantidadeContratoTemporariaByContrato(selectedItem.id).then(resp => {
          if (resp) {
            if (resp.length > 0) {
              setPqExpandableRowsTemp(calculateDefaultExpandedRowKeysTemp(resp as PlanilhaQuantidadeTemporaria[]));
              getVerificarTemporariaComStatusReprovada(selectedItem.id).then(dataReprovado => {
                if (dataReprovado) {
                  sethasPQBtAjustePq(!hasPQBtAjustePq);
                  sethasPQBtAjustePq(true);
                  sethasRecarregarBotaoGridTemporaria(true);
                }
              });

              getVerofocarTemporariaComStatusAguardandoAprovacao(selectedItem.id).then(dataAguardandoAprovacao => {
                if (dataAguardandoAprovacao) {
                  sethasPQBtReprovarPq(true);
                  sethasPQBtAprovarPq(true);
                  sethasRecarregarBotaoGridTemporaria(true);
                }
              });
              setmostraGridPqTemporaria(true);
            } else {
              sethasRecarregarBotaoGrid(true);
            }
          }

          GetVerificarSeContratoEstaComStatusPreCadastradoByContratoId(selectedItem.id).then(data => {
            if (data === true) {
              sethasPQBtCorriPq(false);
              setContratoPreCadastrador(true);
            } else {
              sethasPQBtCorriPq(true);
              setContratoPreCadastrador(false);
            }
          });
          return resp;
        })
        : Promise.resolve(undefined),
    [
      mostraGridPqTemporaria,
      hasAcaoAprovarPq,
      hasAcaoReprovarPq,
      hasAcaoCorrigoPq,
      hasAcaoAjustarPq,
      selectedItem,
      hasAtualizarGridPrincipal,
    ],
    [],
  );

  const GetPQMultiplosGestores = () => {
    setMultiplosGestoresEscopo([]);
    setAllPqUltimosGestores([]);

    getAllPlanilhaQuantidadeMultiplosGestoresByContrato(selectedItem.id).then((data: any) => {
      if (data && data.length > 0) {
        if(hasPermission(['SGC_CONTRATO_VIZUALIZAR_TODAS_SEÇOES_PQ_ASSOCIADAS'])){
          setAllPqUltimosGestores(data);
        }else{
          let arrAux: ContratoPlanilhaQuantidadeAtual[] = data.filter((item:ContratoPlanilhaQuantidadeAtual)=>{
            if(item.isResponsavel){
              return item;
            }
          });
          if(arrAux.length > 0){
            setAllPqUltimosGestores(arrAux);
          }
        }

        let arr:AbaPQEscopoMultiplosGestores[] = data.map((item: any) => {
          return {
            identificador: item.identificador ? item.identificador : 1,
            escopo: item.escopo ? item.escopo : '',
            idPq: item.id,
            isResponsavel : item.isResponsavel
          }
        }).sort((a: any,b: any) => compareStrings(isObjNotEmpty(a.identificador) ? a.identificador : '', isObjNotEmpty(b.identificador) ?  b.identificador : ''));
        setMultiplosGestoresEscopo(arr);
        
        sethasPQ(true);
      } else {
        sethasPQ(false);
      }
    })
  }

  useEffect(() => {
    if (!btnExpandirAtual) setPqRowExpandedAtual(PqExpandableRowsAtual);
    else setPqRowExpandedAtual([]);
  }, [btnExpandirAtual, PqExpandableRowsAtual]);

  useEffect(() => {
    if (!btnExpandirTemp) setPqRowExpandedTemp(PqExpandableRowsTemp);
    else setPqRowExpandedTemp([]);
  }, [btnExpandirTemp, PqExpandableRowsTemp]);

  useEffect(()=>{
    if(isMultiplosGestores){
      GetPQMultiplosGestores();
    }
  },[selectedItem])

  const [getAllplanilhaQuantidade] = usePromise(
    () =>
      selectedItem
        ? getAllPlanilhaQuantidadeAtualByContrato(selectedItem.id).then(data => {
          if (data) {
            if (PqExpandableRowsAtual[0] === '')
              setPqExpandableRowsAtual(calculateDefaultExpandedRowKeys(data as ContratoPlanilhaQuantidadeAtual[]));
          }
          return data as ContratoPlanilhaQuantidadeAtual[];
        })
        : Promise.resolve(undefined),
    [
      itemAdded,
      hasAcaoAprovarPq,
      hasAcaoReprovarPq,
      hasAcaoCorrigoPq,
      hasAcaoAjustarPq,
      selectedItem,
      hasAtualizarGridPrincipal,
    ],
    [],
  );

  const [planilhaQuantidadeContratoByContrato] = usePromise(
    () =>
      selectedItem
        ? getAllPlanilhaQuantidadeContratoByContrato(selectedItem.id).then(rep => {
          if (rep) {
            if (rep.length > 0) {
              sethasPQ(true);
            } else {
              sethasPQ(false);
            }
          }
          return rep;
        })
        : Promise.resolve(undefined),
    [
      itemAdded,
      hasAcaoReprovarPq,
      hasAcaoCorrigoPq,
      hasAcaoAprovarPq,
      hasAcaoAjustarPq,
      selectedItem,
      hasAtualizarGridPrincipal,
      btnExpandirAtual,
    ],
    [],
  );

  const calculateDefaultExpandedRowKeys = (data: ContratoPlanilhaQuantidadeAtual[]) => {
    let keys: string[] = [];
    const mapRowKeys = (source: ContratoPlanilhaQuantidadeAtual[]) => {
      source.forEach(element => {
        if (element.children.length !== 0) {
          mapRowKeys(element.children);
          keys.push(element.id);
        }
      });
    };
    mapRowKeys(data);
    return keys;
  };

  const calculateDefaultExpandedRowKeysTemp = (data: PlanilhaQuantidadeTemporaria[]) => {
    let keys: string[] = [];
    const mapRowKeys = (source: PlanilhaQuantidadeTemporaria[]) => {
      source.forEach(element => {
        if (element.children.length !== 0) {
          mapRowKeys(element.children);
          keys.push(element.id);
        }
      });
    };
    mapRowKeys(data);
    return keys;
  };

  const expandedRowRender = (record:any) => {
    const columnsPqs = [
      {
        title: 'Número',
        dataIndex: 'numero',
        width: '10%',
      },{
        title: 'Status',
        dataIndex: 'statusPlanilha',
        width: '10%',
      },{
        title: 'Data de Inclusão',
        dataIndex: 'dataInclusaoFormatada',
        width: '10%',
      },{
        title: 'Resnponsável',
        dataIndex: 'responsavel',
        width: '10%',
      },{
        title: 'Aditivo Relacionado',
        dataIndex: 'aditivoRelacionado',
        width: '10%',
      },{
        title: 'Valor do Contrato Formatado',
        dataIndex: 'valorContratoFormatado',
        width: '10%',
      },
    ];

    return <div style={{width:'100%'}}><Table columns={columnsPqs} dataSource={record.subItens} pagination={false} rowKey="key"/></div>;
  };

  const columnsMultiplosGestores = [
    {
      title: 'Identificador',
      dataIndex: 'identificador',
      width: '10%',
    },
    {
      title: 'Escopo',
      dataIndex: 'escopo',
      width: '35%',
    },
    {
      title: 'Data de Inclusão',
      dataIndex: 'dataInclusaoFormatada',
      width: '15%',
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      width: '35%',
    },
    {
      title: 'Ações',
      width: '5%',
      render: (text, record, index) =>{
        const onClick =()=> getExportarPqAtualMultiplosGestores(selectedItem.id,record.identificador);
        return (
          record ? 
            <Tooltip title="Exportar Take-Off individual">
              <Button
                type="link"
                icon="files-xls"
                onClick={onClick}
              />
            </Tooltip>: 
            <></>
        )
      }
    },
  ];

  return (
    <>
      <Visibility
        permissions={['CONTRATO_PQ_CADASTRAR','SGC_CONTRATO_VIZUALIZAR_TODAS_SEÇOES_PQ_ASSOCIADAS']}
      >
        <div className="ant-app-unboxed-button">
          <Visibility visible={(!isDefined || isDefined == undefined || isDefined == null) && hasPermission(['SGC_CONTRATO_VIZUALIZAR_TODAS_SEÇOES_PQ_ASSOCIADAS'])}>
            <ModalDefineMultiplosGestores id={selectedItem && selectedItem.id} onUpdate={onUpdate} />
          </Visibility>

          <Visibility visible={isDefined}>
            <Visibility
              visible={isMultiplosGestores == false}
            >
              <ComponeteCurso
                id={selectedItem && selectedItem.id}
                nomeIdFormulario={'ContratoId'}
                enderecoApi={'contratos/updateAssociarAtualizarPlanilhaQuantidade'}
                descricaoBotao={`Adicionar Planilha de Quantidade`}
                retorno={CalBackAcaoAssociarPq}
                idDoComponente="associarAtualizarPq"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </Visibility>

            <Visibility
              visible={isMultiplosGestores == true && !consolidado && hasPermission(['SGC_CONTRATO_VIZUALIZAR_TODAS_SEÇOES_PQ_ASSOCIADAS'])}
            >
              <ModalAdicionaEscopoPQ
                multiplosGestoresEscopo={multiplosGestoresEscopo}
                GetPQMultiplosGestores={GetPQMultiplosGestores}
                isNew={true}
              />
            </Visibility>
          </Visibility>

        </div>
      </Visibility>

      {isMultiplosGestores ? (
        <>
          <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />} defaultActiveKey={'planilhaQuantidade'}>
            <Panel
              key="planilhaQuantidade"
              header={'Planilhas de Quantidade(Consolidado)'}
              style={{ border: 0, padding: 5 }}
            >
              <Widget
                actions={[
                  <Visibility visible={hasPermission(['SGC_CONTRATO_VIZUALIZAR_TODAS_SEÇOES_PQ_ASSOCIADAS']) && isConsolidado}>
                    <Button
                      type="primary"
                      onClick={() => { GetTakeOfMultiplosGestores(selectedItem.id)}}
                      key="close"
                      icon="files-xls"
                    >
                      Exportar Take-Off Consolidado
                    </Button>
                  </Visibility>
                ]}
              >
                <Table
                  rowKey={'identificador'}
                  columns={columnsMultiplosGestores}
                  dataSource={allPqUltimosGestores}
                  pagination={false}
                  expandedRowRender={ record => expandedRowRender(record) }
                />
              </Widget>
            </Panel>
          </Collapse>
          {multiplosGestoresEscopo.map((item) => {
            return (
              <Visibility
                visible={
                  hasPermission(['SGC_CONTRATO_VIZUALIZAR_TODAS_SEÇOES_PQ_ASSOCIADAS']) || 
                  item.isResponsavel
                }
              >
                <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />} defaultActiveKey={item.identificador}>
                  <Panel
                    key={item.identificador}
                    header={`Planilha de Quantidade - PQ ${item.identificador} - ${item.escopo}`}
                    style={{ border: 0, padding: 5 }}
                  >
                    <WidgetPQMultiplosGestores
                      multiplosGestoresEscopo={multiplosGestoresEscopo}
                      pqMultiplosGesotresEscopo={item}
                      selectedItem={selectedItem}
                      getPQMultiplosGestores={GetPQMultiplosGestores}
                      isConsolidado={consolidado}
                      tipoDocumentoCobranca={tipoDocumentoCobranca}/>
                  </Panel>
                </Collapse>
              </Visibility>
            );
          })}
          {multiplosGestoresEscopo.length > 0 && !consolidado &&
            <>
              <Row>
                <Visibility visible={hasPermission(['SGC_CONTRATO_CONSOLIDAR_PQS_MULTIPLOS_GESTORES'])}>
                  <Button
                    type="primary"
                    onClick={() => {
                      ConsolidarPqsMultiplosGestores();
                    }}
                    key="createPqs"
                    style={{ float: 'right', margin: 5 }}
                  >
                    Consolidar
                  </Button>
                </Visibility>
                <Visibility visible={hasPermission(['SGC_CONTRATO_VIZUALIZAR_TODAS_SEÇOES_PQ_ASSOCIADAS'] )}>
                  <Button
                    type="danger"
                    onClick={() => {
                      Modal.confirm({
                        title: 'Cancelar Atualizações',
                        content: 'Todas as associações de Planilha de Quantidade realizada até o momento serão desfeitas.\n Deseja Continuar?',
                        okText: 'Sim',
                        cancelText: 'Não',
                        onOk() {
                          DeleteAllPqMultiplosGestores();
                        },
                      });
                    }}
                    key="deletePqs"
                    style={{ float: 'right', margin: 5 }}
                  >
                    Cancelar
                  </Button>
                </Visibility>
              </Row>
            </>
          }
        </>
      ) : (
        <>
          {hasPQ  && !isMultiplosGestores ? (
            <>
              <Collapse
                bordered={false}
                expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel key="planilhaQuantidade" header={'Planilhas de Quantidade'} style={{ border: 0 }}>
                  <Widget actions={botoesDeAcaoPqGridPrincipal}>
                    <PerfectScrollbar>
                      <Table
                        columns={PlanilhaQuantidadeContratoColumns}
                        dataSource={planilhaQuantidadeContratoByContrato}
                        pagination={false}
                      />
                    </PerfectScrollbar>
                  </Widget>
                </Panel>
              </Collapse>
            </>
          ) : (
            <>

            </>
          )}

          {hasPQ ? (
            <>
              <Collapse
                bordered={false}
                expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel
                  id="panellPlanilhaQuantidade"
                  key="planilhaAtual"
                  header={'Planilha de Quantidade - ATUAL'}
                  style={{ border: 0, height: '100%' }}>
                  <Widget actions={botoesDeAcaoPqAtual}>
                    <MasterDetailForm>
                      <PerfectScrollbar>
                        <Table
                          className="multiple-level-table on-table-fixed-overflow"
                          columns={PlanilhaQuantidadeColumns}
                          dataSource={getAllplanilhaQuantidade}
                          pagination={false}
                          expandedRowKeys={PqRowExpandedAtual}
                          rowKey={'id'}
                          expandIcon={props => {
                            const expanded = !props.record.children.length
                              ? 'ant-table-row-spaced'
                              : props.expanded
                                ? 'ant-table-row-expanded'
                                : 'ant-table-row-collapsed';
                            return (
                              <div
                                className={`ant-table-row-expand-icon ${expanded}`}
                                onClick={e => {
                                  if (PqRowExpandedAtual.includes(props.record.id))
                                    setPqRowExpandedAtual(
                                      PqRowExpandedAtual.filter(element => element !== props.record.id),
                                    );
                                  else {
                                    setPqRowExpandedAtual([...PqRowExpandedAtual, props.record.id]);
                                  }
                                  props.onExpand(props.record, e);
                                }}
                              />
                            );
                          }}
                        />
                      </PerfectScrollbar>
                    </MasterDetailForm>
                  </Widget>
                </Panel>
              </Collapse>
            </>
          ) : (
            <></>
          )}

          {mostraGridPqTemporaria ? (
            <Collapse
              bordered={false}
              expandIcon={() => <Icon type="arrows-right_4" />}>
              <Panel key="planilhaAtualTemp" header={'Planilha de Quantidade - Temporária'} style={{ border: 0 }}>
                <Widget actions={botoesAcaoGridPqTemporaria}>
                  <PerfectScrollbar>
                    <Table
                      onRow={record => {
                        return {
                          onClick: event => {
                            if (PqRowExpandedTemp.includes(record.id))
                              setPqRowExpandedTemp(PqRowExpandedTemp.filter(element => element !== record.id));
                            else {
                              setPqRowExpandedTemp([...PqRowExpandedTemp, record.id]);
                            }
                          },
                        };
                      }}
                      rowKey={'id'}
                      className="multiple-level-table on-table-fixed-overflow"
                      columns={PlanilhaQuantidadeTemporariaColumns}
                      dataSource={planilhaQuantidadeContratoTemporariaByContrato}
                      pagination={false}
                      expandedRowKeys={PqRowExpandedTemp}
                      expandIcon={props => {
                        const expanded = !props.record.children.length
                          ? 'ant-table-row-spaced'
                          : props.expanded
                            ? 'ant-table-row-expanded'
                            : 'ant-table-row-collapsed';
                        return (
                          <div
                            className={`ant-table-row-expand-icon ${expanded}`}
                            onClick={e => {
                              if (PqRowExpandedTemp.includes(props.record.id))
                                setPqRowExpandedTemp(PqRowExpandedTemp.filter(element => element !== props.record.id));
                              else {
                                setPqRowExpandedTemp([...PqRowExpandedTemp, props.record.id]);
                              }
                              props.onExpand(props.record, e);
                            }}
                          />
                        );
                      }}
                    />
                  </PerfectScrollbar>
                </Widget>
              </Panel>
            </Collapse>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default AbaPlanilhaQuantidadeContrato;
